import * as React from 'react';

function SvgSkip(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.916 24.15a.7.7 0 00.7-.7V7.61a.7.7 0 10-1.4 0v6.81l-11.6-7.277a.7.7 0 00-1.073.593v15.587a.7.7 0 001.072.593l11.6-7.277v6.81a.7.7 0 00.7.7zM8.943 22.057L19.35 15.53 8.943 9.001v13.056z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSkip;
